/** Pretty file size — KB, MB, GB. Mirrors the customer-support helper
 * so a 1024 byte file shows up as "1.0 KB" in both tools. Shared with the
 * company Legal page, which sizes the cabinet's files the same way. */
export function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  if (n < 1024 * 1024 * 1024) return `${(n / 1024 / 1024).toFixed(1)} MB`;
  return `${(n / 1024 / 1024 / 1024).toFixed(2)} GB`;
}
